import {
  IAuthorDetails,
  IBookDescription,
  IBookLandingPage,
  ICourseLandingPage,
  ICurriculumLandingPageData,
  IHeroSectionCourseLandingPage,
  IHeroSectionLandingPage,
  IIframeLandingPage,
  IRecommendedAndOverViewSection,
  ISlidBook,
  ISlidCourse,
  ISneakPeek,
  IValueAdditionSection,
} from '../../../utils/interfaces/landingPage';

export const extractHeroSectionData = (
  bookLandingDetails: IBookLandingPage,
): IHeroSectionLandingPage => {
  const isMultipleAuthors = bookLandingDetails?.isMultipleAuthors || false;

  return {
    productHighlightText: bookLandingDetails.productHighlightText,
    productTitle:
      bookLandingDetails.bookName || bookLandingDetails.productTitle,
    bookImage: bookLandingDetails.bookImage,
    hardCopyPrice: {
      mrpPrice: bookLandingDetails.hardCopyPrice?.mrpPrice,
      discountedPrice: bookLandingDetails.hardCopyPrice?.discountedPrice,
      comingSoonPrice: bookLandingDetails.hardCopyPrice?.comingSoonPrice,
    },
    hardCoverProductId: bookLandingDetails.hardCoverProductId,
    bookName: bookLandingDetails.bookName,
    bookBackImage: bookLandingDetails.bookBackImage,
    language: bookLandingDetails.language,
    isbn: bookLandingDetails.isbn,
    rating: bookLandingDetails.rating,
    numberOfPages: bookLandingDetails.numberOfPages,
    bookDescription: bookLandingDetails.bookDescription,
    shortDescription: bookLandingDetails.shortDescription,
    keyPoints: bookLandingDetails.keyPoints,
    bookType: bookLandingDetails.bookType,
    productCouponCode: bookLandingDetails.productCouponCode,
    isMultipleAuthors,

    ...(isMultipleAuthors
      ? {
          authorsList: bookLandingDetails.authorsList ?? [],
        }
      : {
          authorName: bookLandingDetails.authorName,
          authorImage: bookLandingDetails.authorImage,
          authorDescription: bookLandingDetails.authorDescription,
          authorDesignation: bookLandingDetails.authorDesignation,
          companyIcon: bookLandingDetails.companyIcon,
          authorZlUid: bookLandingDetails.authorZlUid,
          authUser_name: bookLandingDetails.authUser_name,
        }),
  };
};

export const extractHeroSectionCourseData = (
  bookLandingDetails: ICourseLandingPage,
): IHeroSectionCourseLandingPage => {
  return {
    productTitle:
      bookLandingDetails.bookName || bookLandingDetails.productTitle,
    authorName: bookLandingDetails.authorName,
    authorImage: bookLandingDetails.authorImage,
    authorDescription: bookLandingDetails.authorDescription,
    authorDesignation: bookLandingDetails.authorDesignation,
    companyIcon: bookLandingDetails.companyIcon,
    shortDescription: bookLandingDetails.shortDescription,
    authorZlUid: bookLandingDetails.authorZlUid,
    authUser_name: bookLandingDetails.authUser_name,
    tags: bookLandingDetails.tags,
  };
};

export const extractSlidBookContainerData = (
  bookLandingDetails: IBookLandingPage,
): ISlidBook => {
  return {
    bookImage: bookLandingDetails?.bookImage,
    productHighlightText: bookLandingDetails?.productHighlightText,
    bookBackImage: bookLandingDetails?.bookBackImage,
    bookType: bookLandingDetails?.bookType,
    productCouponCode: bookLandingDetails?.productCouponCode,
    hardCopyPrice: {
      mrpPrice: bookLandingDetails?.hardCopyPrice?.mrpPrice,
      discountedPrice: bookLandingDetails?.hardCopyPrice?.discountedPrice,
      comingSoonPrice: bookLandingDetails?.hardCopyPrice?.comingSoonPrice,
    },
    softCopyPrice: {
      mrpPrice: bookLandingDetails?.softCopyPrice?.mrpPrice,
      discountedPrice: bookLandingDetails?.softCopyPrice?.discountedPrice,
    },
    digitalProductId: bookLandingDetails?.digitalProductId,
    hardCoverProductId: bookLandingDetails?.hardCoverProductId,
    productTitle: bookLandingDetails?.productTitle,
    bookSideImage: bookLandingDetails?.bookSideImage,
    bookName: bookLandingDetails?.bookName,
    hardCoverAvailable: bookLandingDetails?.hardCoverAvailable,
    readersProductId: bookLandingDetails?.readersProductId,
  };
};

export const extractSlidCourseContainerData = (
  bookLandingDetails: ICourseLandingPage,
): ISlidCourse => {
  return {
    bookImage: bookLandingDetails?.bookImage,
    main_price: bookLandingDetails?.main_price,
    stroked_price: bookLandingDetails?.stroked_price,
    courseSampleLink: bookLandingDetails?.courseSampleLink,
    productId: bookLandingDetails?.productId,
    productTitle: bookLandingDetails?.productTitle,
    bookName: bookLandingDetails?.bookName,
  };
};

export const extractIBookDescriptionData = (
  bookLandingDetails: IBookLandingPage | ICourseLandingPage,
): IBookDescription => {
  return {
    bookDescription: bookLandingDetails?.bookDescription,
    whatYouWillLearn: bookLandingDetails?.whatYouWillLearn,
  };
};

export const extractRecommendedAndOverViewSectionData = (
  bookLandingDetails: IBookLandingPage,
): IRecommendedAndOverViewSection => {
  return {
    reviewerPhoto: bookLandingDetails?.reviewerPhoto,
    reviewerName: bookLandingDetails?.reviewerName,
    reviewerDescription: bookLandingDetails?.reviewerDescription,
    overview: bookLandingDetails?.overview,
    bookIncludes: bookLandingDetails?.bookIncludes,
  };
};

export const extractCurriculumLandingPageData = (
  bookLandingDetails: IBookLandingPage,
): ICurriculumLandingPageData => {
  return {
    chapters: bookLandingDetails?.chapters,
  };
};

export const extractValueAdditionData = (
  bookLandingDetails: IBookLandingPage,
): IValueAdditionSection => {
  return {
    valueAddition: bookLandingDetails?.valueAddition,
  };
};

export const extractSneakPeekData = (
  bookLandingDetails: IBookLandingPage,
): ISneakPeek => {
  return {
    sneakPeek: bookLandingDetails?.sneakPeek,
  };
};

export const extractIframeData = (
  bookLandingDetails: IBookLandingPage,
): IIframeLandingPage => {
  return {
    iframeUrl: bookLandingDetails?.iframeUrl,
    thumbnailUrl: bookLandingDetails?.thumbnailUrl,
  };
};

export const extractAuthorDetailsData = (
  bookLandingDetails: IBookLandingPage | ICourseLandingPage,
): IAuthorDetails => {
  return {
    authorName: bookLandingDetails?.authorName,
    authorImage: bookLandingDetails?.authorImage,
    authorDescription: bookLandingDetails?.authorDescription,
    authorDesignation: bookLandingDetails?.authorDesignation,
    companyIcon: bookLandingDetails?.companyIcon,
  };
};
